import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../nodeIds';

export const middleName: AnswerPathTreeNode = { path: 'middleName', nodeId: NodeIds.insuredMiddleName };
